import React from 'react';
import styled from "styled-components";

const RulesEnglish = () => {
    return (
        <Wrapper>
            <Content>
                <h2> COMPLETE COMPETITION RULES</h2>

                <p>International poster competition for students and graduates of the last 5 years after graduation
                (of all degrees) under the title 550th birthday of Nicolaus Copernicus.
                The competition is held as part of the World Copernican Congress, on the occasion of the year
                2023 being declared the Year of Nicolaus Copernicus by a resolution of the Polish Senate.
                The Congress is organised jointly by Nicolaus Copernicus University in Toruń, Jagiellonian
                University in Kraków, University of Warmia and Mazury in Olsztyn and the Polish Academy of
                Sciences.</p>
                <h2> ORGANISER:</h2>
                <p>University of Warmia and Mazury in Olsztyn, Faculty of Arts and Faculty of Humanities</p>
                <h2> PARTNERS:</h2>
                <p>Nicolaus Copernicus University in Toruń</p>
                <p>Frombork Art Coach House Gallery</p>
                <h2> PURPOSE OF THE COMPETITION:</h2>
                <p>To select the most interesting posters, graphic creations on the theme of the competition - the 550th
                birthday of
                Nicolaus Copernicus.</p>
                <h2> PARTICIPANTS OF THE COMPETITION:</h2>
                <p> The competition is aimed at graduates from the last 5 years and students of art and design universities
                (diploma
                obtained no earlier than 2018).
                Participation in the competition is voluntary and free of charge.
                Competition entries must be realised and submitted individually.
                The competition has an open, two-stage character.</p>
                <h2>TERMS AND CONDITIONS OF PARTICIPATION:</h2>
                <p>1. The competition is open to participants who have read and accept these Regulations.</p>
                <p>2. in order to participate in the competition it is necessary to submit:</p>
                <p>- an entry in accordance with the guidelines specified in the regulations;</p>
                <p> - a completed application form with: address details, name of university, country, in the case of
                graduates
                the year of graduation;</p>
                <p>- a signed Declaration (appendix to the rules).</p>
                <p>3. With the submission of the work, the Author:</p>
                <p>- in accordance with the requirements specified in the Regulations, grants to the Organiser of the
                Competition a non-exclusive licence (together with the right to grant a further licence) without
                territorial
                restrictions and for an indefinite period of time, to use the Work for the purposes of organising the
                Competition and its promotion and for the purposes of realising post-competition exhibitions, as well as
                for promotion and information about the Organiser's statutory activity - in the fields of exploitation
                covering:</p>
                <p>a. in terms of recording and multiplication, production by any technique of an unlimited number of
                copies,
                including printing, reprography, audiovisual, magnetic recording, digital technique,</p>
                <p>b. dissemination in any other way - public exhibition, display, reproduction as well as broadcasting and
                re-broadcasting, including on the Internet, entering into computer memory, transmission via multimedia
                networks, including the Internet, and other public availability in such a way that anyone can access
                them
                at a time and place of their own choosing</p>
                    <p>- declares that the work does not infringe on the rights of third parties, in particular does not
                violate their
                property or personal copyrights
                - consents to the processing of their personal data contained in the competition entry.</p>
                <p>4. Participants shall submit their works as jpg files with the name, surname and number of the work in
                the
                name, e.g. adam_kowalsky_1.jpg. It is, however, forbidden to include the name and surname anywhere
                on the work.</p>
                <p> 5. A maximum of 3 posters may be submitted by a participant in the competition (each must be
                accompanied by a separate entry form).</p>
                <p>6. Prize-winning entries become the property of the competition organiser, who may use them in any way

                he wishes. The authors of the awarded posters transfer to the Organiser the proprietary copyrights to
                the
                works and grant permission to use them in all fields of exploitation.</p>
                <h2>SUBMISSION OF COMPETITION ENTRIES:</h2>
                <p>1. an overview version of each submitted competition entry, together with acceptance of the regulations
                and the
                declaration, must be submitted via the form found on the competition website:
                http://rokkopernika.uwm.edu.pl/konkurs/
                as a digital file: format 10 × 7 cm (portrait orientation only), 300 dpi, RGB, jpg (maximum 5 MB) by 30
                April 2023.</p>
                <p>2. Each jpg file of the work must be named with the artist's first and last name and the work number,
                e.g.
                adam_kowalsky_1.jpg. It is, however, forbidden to mention your name anywhere on the work.</p>
                <p>3. Deadline for submission of competition entries (previews): 30 April 2023.
                Finalists will be informed of the results by e-mail and will be required to send via the form on the
                competition
                website a printable poster file in B1 format, 100 x 70 cm, 200 dpi, jpg, CMYK, (maximum 30 MB): by 30
                May 2023.
                Additional details will be provided to finalists at a later date, in a separate email correspondence.</p>
                <p> 4. Final deadline for Hi-Res finalist artwork to be submitted for printing: 30 May 2023.</p>
                <p> 5. Entries that do not meet the requirements referred to in the Competition Rules or that are submitted
                after the
                deadline will not be assessed by the Jury.</p>
                <p>6.Works containing content commonly regarded as abusive and vulgar will not be admitted to the
                competition.</p>
                <h2> DEADLINES:</h2>
                <p>Competition announcement: 18 February 2023</p>
                <p>Opening of work registration: 15 March 2023</p>
                <p>Design submission date: 30 April 2023 11.59 pm</p>
                <p>List of successful applicants: 15 May 2023</p>
                <p> Hi-Res file submission date: 30 May 2023</p>
                <p> Announcement of finalists and winners: June 2023</p>
                <p> Post-competition exhibitions: June 2023 - December 2023</p>
                <h2> AWARDS:</h2>
                <p>An international jury will select the winners from among the submitted entries:</p>
                <p>Grand Prix - PLN 3000,</p>
                <p>1st Prize - 2000 PLN,</p>
                <p>2nd Prize - 1500 PLN,</p>
                <p>3rd Prize - 1000 PLN,</p>
                <p> Distinction - 500 PLN</p>
                <p>and up to 100 finalists, whose posters will be presented in post-competition exhibitions in the
                Stara Kotłownia exhibition centre in Olsztyn and in Frombork and Toruń. Of the posters shortlisted for
                the finals, the 20 best will be exhibited in the urban space of Olsztyn, Frombork and at the Final Gala in
                Olsztyn during the Copernican Conference. Finalists of the competition will receive appropriate certificates.
                The organiser reserves the right to distribute the prizes differently, to change the dates, places and
                form of the exhibition of the works. It also makes these factors dependent on the epidemic situation (local and global).
                </p> <h2>JURY:</h2>
                <p>1. Entries will be judged by a two-stage international Competition Jury appointed by the Organiser and
                    composed of:</p>
                <h3>Pre-selection jury:</h3>
                <p>1. dr Jarek Bujny, University of Warmia and Mazury, Poland</p>
                <p>2. Prof. Violetta Kulikowska-Parkasiewicz, University of Warmia and Mazury, Poland</p>
                <p>3. Prof. Barnabas Wetton, Designskolen Kolding, Denmark</p>
                <p>4. Prof. Byoung Il Sun, Namseoul University. Korea</p>
                <p>5. Susana Machicao Pacheco, Director of Disenadores Graficos Bolivia, Bolivia</p>

                <h3>Final Jury</h3>
                <p> 1. dr Jarek Bujny, University of Warmia and Mazury, Poland</p>
                <p> 2. dr hab. Agnieszka Ziemiszewska, Polish-Japanese Academy of Information Technology in Warsaw,
                    Poland</p>
                <p> 3. Dr Nikodem Pręgowski, Nicolaus Copernicus University in Toruń, Poland</p>
                <p>4. Rikke Hansen, Denmark</p>
                <p> 5. Prof. Joost Bottema, Merz Akademie, Germany/Netherlands</p>
                <p>2. The Jury's task is to evaluate the entries and select the winners and finalists.</p>
                <p> 3. The results of the competition will be published on the website of the Competition:
                    http://rokkopernika.uwm.edu.pl/konkurs/.</p>
                <p> 4. The decisions of the Jury are final and cannot be appealed.</p>
                <h2> OTHER PROVISIONS:</h2>
                <p> Entering the competition means that, in the event of the selected projects being qualified, their
                    Authors
                    transfer to the Organiser - on an exclusive basis and without territorial and time limitations - the
                    entire
                    copyright to the completed works in the fields of exploitation indicated in Article 50 of the Act of
                    4
                    February 1994 on Copyright and Related Rights (Journal of Laws 2019, item 1231, as amended).
                    Refusal of the aforementioned shall result in the withdrawal of the work from the competition. The
                    Organiser has the right to make any changes to the project that are necessary due to the field of
                    exploitation in which the project will be used; it decides if, when and to what extent the project
                    will
                    be
                    distributed. The Participants of the Competition consent to the processing of their personal data
                    for
                    the
                    purposes necessary for the execution of the Competition in accordance with the Declaration attached
                    hereto. By entering the competition, the participant agrees unreservedly to the terms and conditions
                    of
                    these regulations. Members of the Jury are not allowed to participate in the competition. The
                    organiser
                    of
                    the competition is not responsible for any prolongation, shortening, changes or cancellation of the
                    competition due to reasons beyond its control. </p>
                <h2> ORGANISER'S RESPONSIBILITY:</h2>
                <p> 1 The Organiser shall not be liable for any property damage or non-pecuniary loss, including damage,
                    loss, infringement of bodily integrity or moral injury suffered by the Entrant as a result of
                    his/her
                    participation in the Competition or as a result of the awarding or non-awarding of the prize.</p>
                <p> 2. The Entrant shall be fully and solely responsible in the event that his/her entry in the
                    Competition
                    violates the rights of third parties, the provisions of the Rules or the applicable laws.</p>
                <p>3. The Organizer assumes no responsibility for any error, omission, theft, destruction, substitution,
                    unauthorized access to entries, loss of entries, or delay in delivery to the Organizer caused by
                    factors
                    beyond the Organizer's control.</p>
                <h2> FINAL PROVISIONS: </h2>
                <p>Winners will be informed by email. In all matters not regulated by these Regulations, the relevant
                    provisions of the Civil Code and Regulation (EU) 2016/679 of the European Parliament and of the
                    Council shall apply. Any disputes concerning the Competition arising between the Organiser and the
                    Participants shall be settled by the common court having jurisdiction over the Organiser's
                    registered
                    office. All information can be obtained from the secretariat of the Competition, based at the
                    Faculty of
                    Arts, University of Warmia and Mazury, at; 550poster@uwm.edu.pl</p>

                <br/>
                <a href={'https://firebasestorage.googleapis.com/v0/b/rkkp-uwm.appspot.com/o/RULES-REGULAMIN%20550%20PL%20ENG.pdf?alt=media&token=d7dc52ed-d7d1-4d04-ab53-370242c1b6a1'} download>download rules</a>

            </Content>
        </Wrapper>
    )
}

export default RulesEnglish


const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 12% 10% 0 10%;
  position: relative;

  h1 {
    font-family: Lato;
    color: #E44432;
    font-weight: 800;
    margin-top: 10px;
    padding: 10px;
    border-radius: 50px;
  }

  h3 {
    font-family: Lato;
    color: white;
    background-color: #E44432;
    font-size: 20px;
    font-weight: 600;
    padding: 20px;
    border-radius: 50px;
  }

  h2 {
    font-family: Lato;
    color: #E44432;
    font-weight: 800;
    margin-top: 10px;
    padding: 0px 10px;
    border-radius: 50px;
  }

  p {
    margin: 0;
    font-family: Lato;
    margin-bottom: 12px;
    padding: 0 10px;
    font-size: 14px;
    line-height: 1.5;
  }
`
const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 700px;

  @media (max-width: 768px) {
    width: 100vw;
    box-sizing: border-box;
    padding: 20px;
  }
`

